import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-spec-aandeelhouders',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-spec-aandeelhouders.component.html',
  styleUrl: './tekst-spec-aandeelhouders.component.scss',
})
export class TekstSpecAandeelhoudersComponent {}
